import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

const BreadcrumbOverrideLinkContext = createContext();

const BreadcrumbsOverrideLinkProvider = ({ children }) => {
  const breadcrumbOverrideLinkState = useState({});
  return (
    <BreadcrumbOverrideLinkContext.Provider value={breadcrumbOverrideLinkState}>
      {children}
    </BreadcrumbOverrideLinkContext.Provider>
  );
};

export default BreadcrumbsOverrideLinkProvider;

export const useGetOverrideBreadcrumbLink = key => {
  const [breadcrumbOverrideLinks] = useContext(BreadcrumbOverrideLinkContext);

  return breadcrumbOverrideLinks[key];
};

export const useSetOverrideBreadcrumbLink = key => {
  const [, setBreadcrumbOverrideLink] = useContext(BreadcrumbOverrideLinkContext);

  const setOverrideLink = useCallback(
    value =>
      setBreadcrumbOverrideLink(prev => ({
        ...prev,
        [key]: value
      })),
    [key, setBreadcrumbOverrideLink]
  );

  return { setOverrideLink };
};

export const useAutoOverrideBreadcrumbLink = queryParams => {
  const location = useLocation();
  const { setOverrideLink } = useSetOverrideBreadcrumbLink(location.pathname);

  // Any time query params change, update override value
  useEffect(() => {
    const queryString = qs.stringify(queryParams, {
      addQueryPrefix: true,
      arrayFormat: 'comma',
      encode: false
    });
    setOverrideLink(`${location.pathname}${queryString}`);
  }, [location.pathname, queryParams, setOverrideLink]);
};

export const useResetBreadcrumbOverrideLinkOnload = pathName => {
  const { setOverrideLink } = useSetOverrideBreadcrumbLink(pathName);
  useEffect(() => setOverrideLink(pathName), []);
};
